import { render, staticRenderFns } from "./MainWarehouse.vue?vue&type=template&id=8ff17fe0&scoped=true&"
import script from "./MainWarehouse.vue?vue&type=script&lang=js&"
export * from "./MainWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./MainWarehouse.vue?vue&type=style&index=0&id=8ff17fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff17fe0",
  null
  
)

export default component.exports